import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PersonStateTrueNotiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PersonStateTrueNotiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.6708 8.81095C19.5516 8.81095 21.0763 7.28626 21.0763 5.40547C21.0763 3.52468 19.5516 2 17.6708 2C15.79 2 14.2654 3.52468 14.2654 5.40547C14.2654 7.28626 15.79 8.81095 17.6708 8.81095Z"
        fill="#FC3B26"
      />
      <path
        d="M16.6392 10.1443C15.7742 11.9033 13.9472 13.1188 11.8384 13.1188C8.89767 13.1188 6.50482 10.7552 6.50482 7.84998C6.50482 4.94573 8.89766 2.58216 11.8384 2.58216C12.4289 2.58216 12.9973 2.67746 13.5287 2.85332C13.2732 3.26752 13.0783 3.723 12.9561 4.20744C12.6022 4.10135 12.2269 4.04428 11.8384 4.04428C9.71344 4.04428 7.98505 5.75104 7.98505 7.84998C7.98505 9.94893 9.71343 11.6566 11.8384 11.6566C13.3198 11.6566 14.6084 10.8267 15.2531 9.61283C15.6788 9.85683 16.145 10.0382 16.6392 10.1443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0959 21.2689C19.0959 21.6725 19.4274 22 19.836 22C20.2446 22 20.5762 21.6725 20.5762 21.2689V18.5351C20.5762 16.3314 18.7615 14.539 16.5306 14.539H7.14616C4.91521 14.539 3.1001 16.3314 3.1001 18.5351V21.2689C3.1001 21.6725 3.43161 22 3.84021 22C4.24881 22 4.58033 21.6725 4.58033 21.2689V18.5351C4.58033 17.1377 5.73146 16.0011 7.14616 16.0011H16.5306C17.9453 16.0011 19.0959 17.1377 19.0959 18.5351V21.2689Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PersonStateTrueNotiFalseIcon;
